module.exports = {"status":200,"data":[{"id":1,"yclmc":"封堵剂","dh":"PFT","ggxh":"50KG/桶","dw":"吨","sqsl":"10","bz":""},{"id":2,"yclmc":"封堵剂","dh":"LAT","ggxh":"25KG/袋","dw":"吨","sqsl":"15","bz":""}]}


//////////////////
// WEBPACK FOOTER
// ./src/mock/json/materialPlanMaterial.json
// module id = H+QY
// module chunks = 17